<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M7 19C4.23858 19 2 16.7614 2 14C2 11.7548 3.48944 9.82191 5.57951 9.20473C6.6763 6.68631 9.17712 5 12 5C15.5652 5 18.5079 7.66532 18.9442 11.1121C20.6977 11.5364 22 13.1161 22 15C22 17.1218 20.3436 18.871 18.2052 18.9945L18 19H7ZM17.9711 17.0004L18.1184 16.9966C19.1715 16.9356 20 16.0607 20 15C20 13.8954 19.1046 13 18 13C17.4477 13 17 12.5523 17 12C17 9.23858 14.7614 7 12 7C9.84526 7 7.95271 8.37572 7.26651 10.3812C7.14803 10.7275 6.84983 10.9814 6.48907 11.0432C5.06051 11.2877 4 12.5332 4 14C4 15.6569 5.34315 17 7 17L17.9711 17.0004Z"
    fill="currentColor"
  />
</svg>
